module.exports = __webpack_public_path__ + "media/images/design/images/pickup_img03-d9daaff48ea8ab0122f30e75d8a7fa33.jpg";